import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Constants from '../config/constants';
import FontStyleToggleButtonGroup from './font-style-toggle-button-group';

const DefaultProperties = {
    xOffset: 0,
    yOffset: -200,
    font: Constants.DEFAULT_FONT,
    color: {
        hex: Constants.DEFAULT_FONT_COLOR,
    },
    fontSize: 160,
    style: Constants.STYLE_VERTICAL_ALIGN_TOP | Constants.STYLE_ALIGN_CENTER
};

export default function TextMetadataElement(props) {
    const properties = { ...DefaultProperties, ...props };

    const [xOffset, setXOffset] = useState(properties.xOffset);
    const [yOffset, setYOffset] = useState(properties.yOffset);
    const [font, setFont] = useState(properties.font);
    const [color, setColor] = useState(properties.color);
    const [fontSize, setFontSize] = useState(properties.fontSize);
    const [style, setStyle] = useState(properties.style);

    const { onUpdate } = properties;


    useEffect(() => {
        onUpdate({
            xOffset: xOffset,
            yOffset: yOffset,
            font: font,
            color: color,
            fontSize: fontSize,
            style: style
        });
        // eslint-disable-next-line
    }, [xOffset, yOffset, font, color, fontSize, style])

    return (
        <Grid container spacing={4} columns={{ xs: 2, sm: 6, md: 6, xl: 12 }}>
            <Grid size={5}>
                <Select value={font} label={'Font Family'} fullWidth onChange={event => setFont(event.target.value)}>
                    {Constants.FONT_FAMILIES
                        .map(f => <MenuItem key={f.name} value={f.name}>{f.name}</MenuItem>)}
                </Select>
            </Grid>
            <Grid size={7}>
                <FontStyleToggleButtonGroup fontStyle={style} fontColor={color} onFontStyleUpdate={setStyle} onFontColorUpdate={setColor} />
            </Grid>

            <Grid size={4}>
                <TextField value={fontSize} label={'Font Size'} type="number" required fullWidth onChange={event => setFontSize(event.target.value)} />
            </Grid>
            <Grid size={4}>
                <TextField value={xOffset} label={'X-Offset'} type="number" required fullWidth onChange={event => setXOffset(event.target.value)} />
            </Grid>
            <Grid size={4}>
                <TextField value={yOffset} label={'Y-Offset'} type="number" required fullWidth onChange={event => setYOffset(event.target.value)} />
            </Grid>
        </Grid>
    );
}

TextMetadataElement.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    xOffset: PropTypes.number,
    yOffset: PropTypes.number,
    font: PropTypes.string,
    color: PropTypes.object,
    fontSize: PropTypes.number,
    style: PropTypes.number,
};
